import Nullstack from 'nullstack';
export default function IconZodiacVirgo({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zodiac-virgo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 4a2 2 0 0 1 2 2v9"
  }), "   ", Nullstack.element("path", {
    d: "M5 6a2 2 0 0 1 4 0v9"
  }), "   ", Nullstack.element("path", {
    d: "M9 6a2 2 0 0 1 4 0v10a7 5 0 0 0 7 5"
  }), "   ", Nullstack.element("path", {
    d: "M12 21a7 5 0 0 0 7 -5v-2a3 3 0 0 0 -6 0"
  }), " ");
}